import React, { useState } from 'react';
import styled from 'styled-components';
import IconCheck from '../icons/IconCheck';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useClickOutside from "../../hooks/useClickOutside/useClickOutside";

const Select = styled.div`
  font-size: 12px;
  position: relative;
  cursor: pointer;
  margin-top: 0px;
  .description {
    height: auto;
    width: 100%;
    margin: auto;
    border-radius: 6px;
    padding-top: 0;
    font-family: inherit;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  @media (max-width: 992px) {
    .description {
      border: 1px solid #8b9099;
      font-size: 12px;
    }
    margin-bottom: 10px;
    margin-top: 0px;
  }
`;

export const Li = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding: 8px 10px;
  height: auto;
  width: 100%;
  font-size: 11px;
  border-bottom: 1px solid #f0f0f0;
  
  &:hover {
    background-color: #f9f9f9;
  }
`;

export const Marker = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  flex-shrink: 0;
  svg {
    opacity: 0;
    fill: #fff;
    font-size: 12px;
  }
`;

export const Input = styled.input`
  font-family: GothamLight;
  opacity: 0;
  position: absolute;
  z-index: -1;
  &:checked {
    + ${Marker} {
      background-color: #1890ff;
      border-color: #1890ff;
      svg {
        opacity: 1;
      }
    }
  }
`;

export const Label = styled.span`
  display: inline-block;
  margin-left: 0.5rem;
  color: #595959;
  font-family: GothamLight;
  font-size: 11px;
`;

const EstadoFilter = ({ options = [], selectedEstados = [], onFilterChange = () => {}, description = "ESTADO" }) => {
  const [open, setOpen] = useState(false);
  const [tempSelected, setTempSelected] = useState(selectedEstados || []);

  let selectContainer = useClickOutside(() => {
    setOpen(false);
  });

  const handleCheckboxChange = (option) => {
    const isSelected = tempSelected.some(sel => sel.id === option.id);
    let newSelected;
    
    if (isSelected) {
      newSelected = tempSelected.filter(sel => sel.id !== option.id);
    } else {
      newSelected = [...tempSelected, option];
    }
    
    setTempSelected(newSelected);
  };

  const handleApplyFilter = () => {
    onFilterChange(tempSelected);
    setOpen(false);
  };

  const handleClearAll = () => {
    setTempSelected([]);
  };

  const handleSelectAll = () => {
    setTempSelected([...(options || [])]);
  };

  React.useEffect(() => {
    setTempSelected(selectedEstados || []);
  }, [selectedEstados]);

  /* console.log('EstadoFilter - options:', options, 'selectedEstados:', selectedEstados); */

  return (
    <div ref={selectContainer}>
      <Select>
        <div className='description hand-pointer' onClick={() => setOpen(!open)}>
          {description} <FontAwesomeIcon size={"xs"} icon={['fas', 'filter']} transform="right-2" className="hand-pointer change-requested-field-clock" />
        </div>
        <div className="custom-scroll" style={{ width: '100%' }}>
          <div className={(open === true) ? 'filters-modal-open modal-Filtros' : 'filters-modal-closed modal-Filtros'} style={{ width: '280px !important', minWidth: '280px' }}>
            <div className="row" style={{ margin: 0 }}>
              <div className="col-sm-12" style={{ padding: 0 }}>
                <div className="custom-select-options p-2">
                  <div style={{ marginBottom: '8px', display: 'flex', gap: '4px' }}>
                    <button 
                      className="btn btn-sm btn-outline-success" 
                      onClick={handleSelectAll}
                      disabled={tempSelected.length === (options?.length || 0)}
                      style={{ fontSize: '10px', padding: '3px 6px', flex: 1 }}
                    >
                      Todo
                    </button>
                    <button 
                      className="btn btn-sm btn-outline-danger" 
                      onClick={handleClearAll}
                      disabled={tempSelected.length === 0}
                      style={{ fontSize: '10px', padding: '3px 6px', flex: 1 }}
                    >
                      Limpiar
                    </button>
                  </div>
                  
                  <div style={{ maxHeight: '200px', overflowY: 'auto', display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {options && Array.isArray(options) && options.length > 0 ? (
                      options.map((option, idx) => (
                        <Li key={`${option.id}-${idx}`}>
                          <Input
                            type="checkbox"
                            id={`estado-${option.id}`}
                            checked={tempSelected.some(sel => sel?.id === option.id)}
                            onChange={() => handleCheckboxChange(option)}
                          />
                          <Marker><IconCheck /></Marker>
                          <Label>{option.label || option.name || 'Sin nombre'}</Label>
                        </Li>
                      ))
                    ) : (
                      <p style={{ padding: '8px', margin: 0, color: '#999', fontSize: '11px' }}>No hay opciones</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='listar-aplicar-filtros-button font-gothan-medium' onClick={handleApplyFilter}>
              Aplicar Filtros
            </div>
          </div>
        </div>
      </Select>
    </div>
  );
};

export default EstadoFilter;
